import React from "react";

export function GrayBox({ children, margin = "" }) {
  return (
    <section className={`bg-gray-light p-8 shadow-small ${margin}`}>
      {children}
    </section>
  );
}
